import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = n => (_pushScopeId("data-v-6d7149fc"), n = n(), _popScopeId(), n);
var _hoisted_1 = ["id", "alt", "src", "width", "height", "loading"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("img", {
    id: _ctx.$attrs.id,
    class: _normalizeClass(['tw-inline-block', _ctx.iconType, _ctx.iconClass]),
    alt: _ctx.altAttribute || _ctx.$attrs.alt,
    style: _normalizeStyle(_ctx.$attrs.style),
    src: _ctx.$attrs.src ? _ctx.$attrs.src : "".concat(_ctx.cdn, "/_ui/img/Ico/").concat(_ctx.iconName),
    width: _ctx.$attrs.width,
    height: _ctx.$attrs.height,
    loading: _ctx.lazyLoading ? 'lazy' : 'eager'
  }, null, 14 /* CLASS, STYLE, PROPS */, _hoisted_1);
}